import React, { useState, useEffect } from "react";
import { Button, Menu, MenuItem, Popper, Paper, Typography, Avatar, Divider } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import UserDetails from "../../../../utils/auth/UserDetails";
const UserAccountButton = ({ selectedSection, onSectionChange }) => {

    const userDetails = UserDetails();

    const { instance } = useMsal();
    const [anchorEl, setAnchorEl] = useState(null);
    const [hoverAnchorEl, setHoverAnchorEl] = useState(null);
    const [profileData, setProfileData] = useState({
        photo: null,
        jobTitle: "N/A",
        phoneNumber: "N/A",
        department: "N/A",
    });

    const handleSignOut = () => {   
        instance.logoutRedirect();
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            const account = instance.getActiveAccount();
            if (!account) return;

            try {
                const tokenResponse = await instance.acquireTokenSilent({
                    scopes: ["user.read"],
                });

                let photo = null;
                try {
                    const photoResponse = await axios.get(
                        "https://graph.microsoft.com/v1.0/me/photo/$value",
                        {
                            headers: { Authorization: `Bearer ${tokenResponse.accessToken}` },
                            responseType: "arraybuffer",
                        }
                    );
                    photo = URL.createObjectURL(
                        new Blob([photoResponse.data], { type: photoResponse.headers["content-type"] })
                    );
                } catch { }

                const userResponse = await axios.get("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${tokenResponse.accessToken}` },
                });

                setProfileData({
                    photo,
                    jobTitle: userResponse.data.jobTitle || "N/A",
                    phoneNumber: userResponse.data.mobilePhone || userResponse.data.businessPhones?.[0] || "N/A",
                    department: userResponse.data.department || "N/A",
                });
            } catch { }
        };

        fetchProfileData();
    }, [instance]);

    return (
        <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Button
                sx={{
                    position: "fixed",
                    bottom: 16,
                    left: 10,
                    borderRadius: "50%",
                    width: 30,
                    height: 30,
                    minWidth: 30,
                    padding: 0,
                    bgcolor: selectedSection === "account" ? "#1976d2" : "transparent",
                    "&:hover": { bgcolor: "#1565c0" },
                }}
                onClick={(event) => setAnchorEl(event.currentTarget)}
            >
                {profileData.photo ? (
                    <Avatar src={profileData.photo} sx={{ width: 30, height: 30 }} />
                ) : (
                    <i className="pi pi-user" style={{ fontSize: 24 }}></i>
                )}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                position="bottom-end"
                onClose={() => setAnchorEl(null)}
                sx={{ mt: 1, ml: 5 }}

                slotProps={{
                    paper: {
                        elevation: 1,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 6,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                bottom: -4,
                                left: 14,
                                width: 10,
                                height: 10,
                                bgcolor: "background.paper",
                                transform: "translateY(-50%) rotate(45deg)",
                                zIndex: 50,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}

            >
                <MenuItem>
                    <Avatar src={profileData.photo} sx={{ width: 48, height: 48, mr: 2 }} />
                    <div >
                        <Typography variant="body1" style={{ width: "180px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={userDetails?.name}>{userDetails?.name}</Typography>
                        <Typography variant="body2" color="textSecondary" style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={profileData.jobTitle}>
                            {profileData.jobTitle}
                        </Typography>
                    </div>
                </MenuItem>
                <Divider />
                <MenuItem>
                    <Typography variant="body2" style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={userDetails?.username}>{userDetails?.username}</Typography>
                </MenuItem>
                <MenuItem>
                    <Typography variant="body2" style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={profileData?.phoneNumber}>{profileData?.phoneNumber}</Typography>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleSignOut} sx={{ color: "red" }}>
                    <i className="pi pi-sign-out" style={{ marginRight: 8 }}></i> Logout
                </MenuItem>
            </Menu>

            <Popper
                open={Boolean(hoverAnchorEl)}
                anchorEl={hoverAnchorEl}
                sx={{ mt: 1,ml:10, zIndex: 1600 }}
                placement="right"
                disablePortal

                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}


                onMouseEnter={() => setHoverAnchorEl(hoverAnchorEl)}
                onMouseLeave={() => setHoverAnchorEl(null)}
            >
                <Paper sx={{ p: 1, bgcolor: "white", boxShadow: 3,ml:2 }}>
                    <Button
                        size="small"
                        onClick={handleSignOut}
                        sx={{
                            color: "black",
                            display: "flex",
                            alignItems: "center",
                            textTransform: "none",
                        }}
                    >
                        <i className="pi pi-sign-out" style={{ marginRight: 8 }}></i> Logout
                    </Button>
                </Paper>
            </Popper>
        </div>
    );
};

export default UserAccountButton;
